import React,{useState,useContext,useEffect} from "react";
import { useNavigate, Link } from "react-router-dom";
import { getReturnInvoiceList } from "../services/invoiceService";
import { CustomerContext } from "../context/customerContext";
import DashboardLayout from "./DashboardLayout";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";

const ReturnInvoiceInfo = () => {
  const [returnInvoices, setReturnInvoices] = useState([]);
  const { customer, setCustomer } = useContext(CustomerContext);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const navigate = useNavigate();

  

  const fetchReturnInvoices = async (from = null, to = null) => {
    try {
      const token = localStorage.getItem("token");
     
      const params = {
        customerId: customer.customerId,
      };
      if (from) params.fromDate = from;
      if (to) params.toDate = to;
  
      const response = await getReturnInvoiceList(params);
      const sortedData = (response.data || []).sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
      setReturnInvoices(sortedData);
    } catch (error) {
      console.error("خطا در دریافت فاکتورها:", error);
    }
  };

  const handleFilter = () => {
    const from = fromDate
      ? fromDate.toDate().toISOString().split("T")[0]
      : null;
    const to = toDate ? toDate.toDate().toISOString().split("T")[0] : null;

    fetchReturnInvoices(from, to);
  };

  useEffect(() => {
    // fetchInvoices(); // بدون فیلتر بار ا
    if (!customer?.customerId) return;
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);
    fetchReturnInvoices(
      sevenDaysAgo.toISOString().split("T")[0],
      today.toISOString().split("T")[0]
    );
  }, [customer]);

    // صفحه‌بندی:
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentInvoices = returnInvoices.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(returnInvoices.length / itemsPerPage);
    if (!returnInvoices) {
        return (
          <DashboardLayout>
            <div className="text-center text-blue-800">
              در حال بارگذاری اطلاعات مالی...
            </div>
          </DashboardLayout>
        );
      }

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between  mb-4">
        <h1 className="text-base sm:text-lg md:text-xl  font-bold text-blue-700">
          فاکتورهای مشتری
        </h1>
        <button
          onClick={() => navigate(-1)}
          className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
        >
          بازگشت
        </button>
      </div>
      {/* <div className="space-y-6"> */}
      <div className="bg-white p-4 rounded shadow text-sm space-y-4">
        {/* ✅ فیلدهای تاریخ در یک ردیف واکنش‌گرا حتی در موبایل */}
        <div className="flex flex-wrap items-center gap-y-2 gap-x-2 sm:gap-x-4">
          {/* از تاریخ */}
          <div className="flex items-center gap-1 whitespace-nowrap">
            <span className="text-sm">از تاریخ:</span>
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              value={fromDate}
              onChange={setFromDate}
              format="YYYY/MM/DD"
              inputClass="border rounded px-1 py-1 w-24 sm:w-28 md:w-32 lg:w-36 text-center text-xs sm:text-sm"
            />
          </div>

          {/* تا تاریخ */}
          <div className="flex items-center gap-1 whitespace-nowrap">
            <span className="text-sm">تا تاریخ:</span>
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              value={toDate}
              onChange={setToDate}
              format="YYYY/MM/DD"
              inputClass="border rounded px-1 py-1 w-24 sm:w-28 md:w-32 lg:w-36 text-center text-xs sm:text-sm"
            />
          </div>
           {/* دکمه فیلتر */}
        <div className="sm:mt-0 w-full sm:w-auto">
          <button
            onClick={handleFilter}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-500 w-full sm:w-auto"
          >
            اعمال فیلتر
          </button>
        </div>
        </div>

        {/* توضیح */}
        <p className="text-gray-600 text-xs">
          گزارش فاکتور حداکثر تا ۶۰ روز گذشته
        </p>

       
      </div>

      {/* ✅ جدول فاکتورها */}
      {/* <table className="w-full text-sm text-right bg-white shadow rounded-xl overflow-x-auto"> */}
      <div className="w-full overflow-x-auto rounded-xl">
        <table className="w-full min-w-[400px] sm:min-w-[500px] text-sm text-right bg-white shadow rounded-xl overflow-hidden">
          <thead className="bg-blue-100 text-blue-900">
            <tr>
              <th className="px-3 py-1 sm:px-2 sm:py-2">ردیف</th>
              <th className="px-3 py-1 sm:px-2 sm:py-2">شماره فاکتور برگشتی</th>
              <th className="px-3 py-1 sm:px-2 sm:py-2">تاریخ</th>
              <th className="px-3 py-1 sm:px-2 sm:py-2">مبلغ (ریال)</th>
              {/* <th className="px-2 py-1 sm:p-3">وضعیت تسویه</th>
              <th className="px-2 py-1 sm:p-3">مانده تسویه نشده</th> */}
            </tr>
          </thead>
          <tbody>
            {currentInvoices.map((inv, index) => (
              <tr key={inv.id} className="border-t hover:bg-blue-50">
                <td className="px-3 py-1 sm:px-2 sm:py-2 ">{index + 1}</td>{" "}
                {/* شماره ردیف */}
                <td className="px-3 py-1 sm:px-2 sm:py-2 text-blue-700 font-bold">
                  <Link
                    to={`/returnInvoiceItems-details/${inv.returnInvoiceID}`}
                    state={{
                      number: inv.number,
                      date: inv.date,
                      customerName: customer?.customerName, // از ست‌شده‌ی صفحه
                      customerCode: customer?.customerCode,
                    }}
                    className="hover:underline"
                  >
                    {inv.number}
                  </Link>
                </td>
                {/* <td className="p-3">{inv.date.split("T")[0]}</td> */}
                <td className="px-3 py-1 sm:px-2 sm:py-2 ">
                  {new DateObject({
                    date: inv.date,
                    calendar: "gregorian", // مشخص کردن ورودی میلادی
                  })
                    .convert(persian) // تبدیل به تقویم شمسی
                    .format("YYYY/MM/DD")}
                </td>
                <td className="px-3 py-1 sm:px-2 sm:py-2 ">
                  {inv.netPrice.toLocaleString()}
                </td>
                {/* <td className="px-2 py-1 sm:p-3">{inv.stateString}</td>
                <td className="px-2 py-1 sm:p-3">
                  {inv.remainAmount != null && inv.remainAmount !== 0
                    ? inv.remainAmount.toLocaleString()
                    : ""}
                </td> */}
              </tr>
            ))}
            {returnInvoices.length === 0 && (
              <tr>
                <td colSpan="4" className="p-4 text-center text-gray-500">
                  فاکتوری یافت نشد.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* صفحه‌بندی */}
      {totalPages > 1 && (
        <div className="flex justify-center gap-2 mt-4 flex-wrap">
          {/* دکمه قبلی */}
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            className={`px-3 py-1 rounded ${
              currentPage === 1 ? "bg-gray-300 text-gray-600" : "bg-blue-100"
            }`}
          >
            قبلی
          </button>

          {/* صفحه‌ها - فقط ۵ عدد نمایش داده شود */}
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((page) => {
              if (totalPages <= 5) return true;
              if (currentPage <= 3) return page <= 5;
              if (currentPage >= totalPages - 2) return page >= totalPages - 4;
              return Math.abs(currentPage - page) <= 2;
            })
            .map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`px-3 py-1 rounded ${
                  currentPage === page
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-700"
                }`}
              >
                {page}
              </button>
            ))}

          {/* دکمه بعدی */}
          <button
            disabled={currentPage === totalPages}
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            className={`px-3 py-1 rounded ${
              currentPage === totalPages
                ? "bg-gray-300 text-gray-600"
                : "bg-blue-100"
            }`}
          >
            بعدی
          </button>
        </div>
      )}
      {/* </div> */}
    </DashboardLayout>
  );

};
  

export default ReturnInvoiceInfo;
